import { Dialog } from "components/ui/Dialog";
import { describeDischargeSubject } from "features/documents/utils/dischargeSummary";
import { CommonResultDetails } from "features/results/components/CommonResultDetails/CommonResultDetails";
import { formatCommonDate } from "features/results/utils/formatters";

import styles from "./DischargeSummariesTable.module.css";

/*
 * The hospital's letter, rendered through its own HSE stylesheet — the same component the Results
 * screen uses, since the row already carries the XML and the stylesheet.
 *
 * The sending hospital is named in the letter's own banner. It is not a field on the row, so it is
 * read there rather than guessed from the XML (see the note on the ticket).
 */
export const DischargeSummaryModal = ({ summary, onClose }) => (
  <Dialog
    open={!!summary}
    onClose={onClose}
    title="Discharge summary"
    width={980}
    minHeight={520}
  >
    {!!summary && (
      <>
        <p className={styles.modalMeta}>
          {formatCommonDate(summary.orderDate)} ·{" "}
          {describeDischargeSubject(summary)}
        </p>
        <CommonResultDetails item={summary} />
      </>
    )}
  </Dialog>
);
